const id_master_goods = {
	access_chasier: "akses kasir",
	access_request: "akses permintaan",
	add: "tambah barang",
	barcode: "barcode",
	edit: "ubah barang",
	name: "nama barang",
	price: "harga barang",
	upload: "unggah barang",
	view: "detail barang",

	form: {
		courier: "kurir instan",
		low_stock: "peringatan stok minimum",
		name: "nama barang",
		min_order: "minimum pesanan",
		po: "barang pre-order",
		po_time: "lama pre-order",
		ppn_label: "* harga termasuk PPN",
		stock: "non stok / stok",
	},

	message: {
		note_upload: "Catatan: hanya format Excel yang dapat diunggah.",
		note_excel: "Unduh contoh file Excel",
		note_term_title: "Ketentuan file:",
		note_term_1: "Gunakan file contoh.",
		note_term_2: "Kolom NamaBarang, Tipe, TipeStok, Keterangan, Lokasi, HargaBeli, HargaJual, dan StokMinimum wajib diisi.",
		note_term_3: "Nama barang yang sudah ada di database tidak akan diinput ulang.",
		note_term_4: "Kolom Barcode tidak wajib diisi. Sistem akan membuatkannya jika kosong.",
		note_term_5: "Kolom Lokasi merupakan lokasi penyimpanan barang.",
		note_term_6: "Kolom Berat diisi dalam satuan gram.",
		note_term_7: "Kolom Satuan digunakan sebagai standar kuantitas barang dalam transaksi.",
		note_term_8: "Kolom StokMinimum digunakan untuk memberikan peringatan jika stok hampir habis.",
		note_term_9: "Tipe barang harus diisi dengan:",
		note_term_9_1: 'Angka "1" untuk barang tanpa nomor seri.',
		note_term_9_2: 'Angka "2" untuk barang dengan nomor seri. Nomor seri diinput saat barang masuk ke gudang.',
		note_term_9_3: 'Angka "3" untuk barang dengan nomor seri. Nomor seri diinput sebelum barang keluar dari gudang.',
		note_term_10: "Kolom TipeStok harus diisi dengan angka 1 (memiliki stok) atau 0 (tidak memiliki stok / jasa).",
		note_term_11: "Kolom Merek, Warna, dan Ukuran diisi jika diperlukan.",
	},

	error: {
		category: "Kategori barang tidak boleh kosong.",
		create: "Gagal membuat barang.",
		delete: "Gagal menghapus barang.",
		edit: "Gagal mengubah barang.",
		name: "Nama barang tidak boleh kosong.",
		po_duration: "Lama pre-order harus lebih dari 0.",
		unit: "Satuan barang tidak boleh kosong.",
		type: "Tipe barang tidak boleh kosong.",
		whs1: "Gudang barang tidak boleh kosong.",
		whs2: "Minimal terdapat 1 gudang.",
	},

	success: {
		create: "Berhasil membuat barang.",
		delete: "Berhasil menghapus barang.",
		edit: "Berhasil mengubah barang.",
	}
}

export default id_master_goods